import React from 'react';
import styled from 'styled-components';
import { device } from '../../assets/device'
import EventDateInfo from './EventDateInfo';
import EventTicketButton from './EventTicketButton';
import EventImageVideoGalleryWrapper from './EventImageVideoGalleryWrapper';

export const EventSummaryStyles = {
	EventSummaryWrapper: styled.div`
		width: 100%;
		display: flex;
		flex-wrap: wrap;

	`,
	EventTitle: styled.h2`
		width: 100%;
		font-weight: 300;
		margin-bottom: 0.8rem;
		order: 1;
		font-size: 2rem;
		display: flex;
		span {
			flex-grow: 1;
			word-wrap: break-word;
			word-break: break-word;
			color: #484646;
		}
	`,
	EventSubtitle: styled.h3`
		font-weight: 300;
		margin-bottom: 1rem;
		width: 100%;
		order: 2;
		font-size: 1.3rem;
		line-height: 1.1;
	`,
	EventImageVideoGallery: styled.div`
		height: calc(${props => (props.$height ? props.$height : 1)} * (100vw / 1.33));
		order: 4;
		margin-bottom: 1.5em;
		width: 100%;
      	//noinspection ALL
		@media ${device.tablet} {
			height: calc(${props => (props.$height ? props.$height : 1)} * (100vw / 5));
			flex: 2;
			order: 3;
			padding: 0 1rem 0 0;
		}
	`,
	EventDescriptionContainer: styled.div`
		order: 5;
		padding: 0;
		margin-bottom: 1.5em;
      	//noinspection ALL
	  	@media ${device.tablet} {
			padding: 0 1rem 0 0;
			flex: 4;
			order: 4;
		}
	`,
	DescriptionText: styled.span`
		display: block;
		white-space: pre-wrap;
		word-break: break-word;
	`,
	Button: styled.button`
		border: none;
		background: none;
		color: red;
		outline: inherit;
		cursor: pointer;
		padding: 0 6px;
		position: inherit;
		vertical-align: middle;

		i {
			line-height: 1em;
			vertical-align:top;
		}
	`,
	EventDateInfoContainer: styled.div`
		order: 3;
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		align-content: flex-start;
      	//noinspection ALL
	  	@media ${device.tablet} {
			order: 5;
			width: 12rem;
		}
	`,
	EventDateInfo: styled.div`
		border: 1px solid rgba(0,0,0,.1);
		border-radius: 2px;
		width: 100%;
		margin-bottom: 1em;
      	//noinspection ALL
		@media ${device.tablet} {
			height: 10rem;
			margin-bottom: .5em;
		}
	`,
	EventTicketButton: styled.div`
		display: ${props => (props.$desktop && 'none')};
		width: 100%;
		order: 6;
		align-self: flex-start;
      	//noinspection ALL
		@media ${device.tablet} {
			display: ${props => (props.$mobile ? 'none': 'flex')};
		}
	`,

	EventTicketIconButton: styled.div`
		display: ${props => (props.$hide && 'none')};
		font-size: 8px;
		float: right;
		top: 0;
		margin-left: .5em;
      	//noinspection ALL
	  	@media ${device.tablet} {
			display: none;
		}
	`,
	StartOfSaleInfo: styled.div`
		order: 7;
		display: ${props => (props.$hide ? 'none' : 'flex')};
		width: 100%;
		color: red;
		align-items: center;
		span {
			font-size: 1.2rem;
		}
		i{
			font-size: 1.3rem;
    		line-height: 1.85rem;
			margin-right: 0.1rem;
		}
	`,
};

const S = EventSummaryStyles;
const shortenedDescriptionLength = 500;

class EventSummary extends React.Component {
	constructor(props) {
		super(props);

		let shortenedDescription;
		let showDescToggleButton;
		if (props.event.description && props.event.description.length > shortenedDescriptionLength) {
			shortenedDescription = `${props.event.description.substring(0, shortenedDescriptionLength)}...`;
			showDescToggleButton = true;
		} else {
			shortenedDescription = props.event.description;
			showDescToggleButton = false;
		}

		let EventImageVideoGalleryWrapperHeight;
		let EventImageVideoGalleryWrapperCSSClassName;
		// Filter filters out mock-Images of Type Inference Workauround
		const images = props.event.images.filter(imageObj => imageObj.fileMetaDataId >= 0);
		// Filter filters out mock-Videos of Type Inference Workauround
		const videos = props.event.youTubeVideos.filter(videoObj => videoObj.videoId !== '-1');

		if (images.concat(videos).length > 1) {
			EventImageVideoGalleryWrapperHeight = '1';
			EventImageVideoGalleryWrapperCSSClassName = '';
		} else {
			EventImageVideoGalleryWrapperHeight = '.75';
			EventImageVideoGalleryWrapperCSSClassName = 'no-thumbnail-navigation';
		}

		const showTicketButton = props.event.lifecyclePhase === 'ON_SALE';
		const startOfSaleText = props.event.startOfSale ? props.event.startOfSale : 'Vorverkauf hat noch nicht begonnen.';

		this.state = {
			showFullDescription: false,
			description: props.event.description,
			shortenedDescription,
			showDescToggleButton,
			EventImageVideoGalleryWrapperHeight,
			EventImageVideoGalleryWrapperCSSClassName,
			images,
			videos,
			startOfSaleText,
			showTicketButton,
		};
	}


	toggleShowFullDescription() {
		this.setState({
			showFullDescription: !this.state.showFullDescription,
		});
	}

	render() {
		return (
			<S.EventSummaryWrapper>
				<S.EventTitle>
					<span>{this.props.event.title}</span>
					{/* Additional Ticket-Button next to the Headline was removed because no need
					<S.EventTicketIconButton hide={!this.state.showTicketButton && true}>
						<EventTicketButton event={this.props.event} iconButton />
					</S.EventTicketIconButton> */}
				</S.EventTitle>
				{this.props.event.subtitle &&
					<S.EventSubtitle>{this.props.event.subtitle}</S.EventSubtitle>
				}
				<S.EventDateInfoContainer>
					<S.EventDateInfo>
						<EventDateInfo event={this.props.event} />
					</S.EventDateInfo>
					{this.state.showTicketButton && <S.EventTicketButton $desktop>
						<EventTicketButton event={this.props.event}/>
					</S.EventTicketButton>}
				</S.EventDateInfoContainer>
				{ ((this.state.images && this.state.images.length > 0) ||
					(this.state.videos && this.state.videos.length > 0)) &&
					<S.EventImageVideoGallery
						height={this.state.EventImageVideoGalleryWrapperHeight}
						className={this.state.EventImageVideoGalleryWrapperCSSClassName}
					>
						<EventImageVideoGalleryWrapper
							images={this.state.images}
							videos={this.state.videos}
						/>
					</S.EventImageVideoGallery>
				}
				<S.EventDescriptionContainer>
					<S.DescriptionText>
						{this.state.showFullDescription ?
							this.state.description : this.state.shortenedDescription}
						{
							this.state.showDescToggleButton &&
							<S.Button onClick={() => this.toggleShowFullDescription()}>
								{this.state.showFullDescription ? <i className="material-icons">expand_less</i> : <i className="material-icons">expand_more</i>}
							</S.Button>
						}
					</S.DescriptionText>
				</S.EventDescriptionContainer>
				{this.state.showTicketButton && <S.EventTicketButton $mobile $hide={!this.state.showTicketButton && true}>
					<EventTicketButton event={this.props.event}/>
				</S.EventTicketButton>}
				<S.StartOfSaleInfo $hide={this.state.showTicketButton && true}>
					<i className="material-icons">info</i><span>{this.state.startOfSaleText}</span>
				</S.StartOfSaleInfo>

			</S.EventSummaryWrapper>
		);
	}
}


export default EventSummary;
